import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SignIn from "./pages/SignIn";
import SidebarLayout from "./components/SidebarLayout";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import UsersPage from "./pages/Users";
import SingleUser from "./pages/SingleUser";
import CronManager from "./pages/CronManager";
import MediaGalleryPage from "./pages/MediaGallery";
import SystemInfo from "./pages/SystemInfo";
import ReportsPage from "./pages/ReportsPage";
import Notifications from "./pages/Notifications";
import AuditLogs from "./pages/AuditLogs";
import AdminsPage from "./pages/AdminsPage";
import AdminSettings from "./pages/AdminSettings";
import PersonalityList from "./pages/PersonalityList";
import PersonalityEdit from "./pages/PersonalityEdit";
import PlayList from "./pages/PlayList";
import AddSong from "./pages/AddSong";
import EventManager from "./pages/EventManager";
import EventEdit from "./pages/EventEdit";
import EventAttendees from "./pages/EventAttendees";
import TransactionsPage from "./pages/Transactions";
import AnalyticsPage from "./pages/Analytics";

// A simple component for protecting routes
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/signin" replace />;
  }
  return children;
};

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/signin" element={<SignIn />} />

      {/* Protected Routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <SidebarLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:userId" element={<SingleUser />} />
        <Route path="media" element={<MediaGalleryPage />} />
        <Route path="managers" element={<AdminsPage />} />
        <Route path="subscriptions" element={<div className="p-6">Subscriptions Page</div>} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="transactions" element={<TransactionsPage />} />
        <Route path="cron-manager" element={<CronManager />} />
        <Route path="system" element={<SystemInfo />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="audit-logs" element={<AuditLogs />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="profile" element={<Profile />} />
        <Route path="personalities/edit/:id" element={<PersonalityEdit />} />
        <Route path="personalities" element={<PersonalityList />} />
        <Route path="events" element={<EventManager />} />
        <Route path="events/create" element={<EventEdit />} />
        <Route path="events/edit/:id" element={<EventEdit />} />
        <Route path="events/attendees/:id" element={<EventAttendees />} />
        <Route path="playlist" element={<PlayList />} />
        <Route path="playlist/create" element={<AddSong />} />
        <Route path="playlist/edit/:id" element={<AddSong />} />
      </Route>

      {/* Redirect root to /signin */}
      <Route path="/" element={<Navigate to="/signin" />} />
    </Routes>
  );
}

export default App;
